import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function routesReducer(state = initialState.routes, action) {
    switch (action.type) {
        case types.LOAD_ROUTES_SUCCESS:
            return action.routes;
        case types.LOAD_ROUTES_SEARCH_SUCCESS:
            return {
                ...state,
                searchResults: action
            };
        case types.LOAD_ROUTES_MYROUTES_SUCCESS:
            return {
                ...state,
                myRoutesResults: action
            };
        case types.LOAD_ROUTES_BOOKMARKS_SUCCESS:
            return {
                ...state,
                bookmarksResults: action
            };
        case types.CREATE_ROUTE_SUCCESS:
            if (state.myRoutesResults.results) {
                return {
                    ...state,
                    myRoutesResults: {}
                };
            }
            return state;
        case types.DELETE_ROUTE:
            if (state.myRoutesResults.results) {
                return {
                    ...state,
                    myRoutesResults: {}
                };
            }
            return state; 
        case types.LOGOUT_SUCCESS:
            return initialState.routes;
        default:
            return state; 
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/routesReducer.js